// import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { lock, unlock } from 'tua-body-scroll-lock';
import SmoothScroll from 'smooth-scroll';
export default class NavEvent {
  constructor() {
    this.init();
  }
  init() {
    const toggles = document.querySelector('.js-NavToggle');
    const Nav = document.querySelector('.js-NavContent');

    // const bd = document.querySelector('.p_headerBodyBg');

    // bd.addEventListener('click', (e) => {
    //   unlock(Nav, { overflowType: 'clip' });
    //   Nav.classList.remove('Act');
    //   toggles.classList.remove('Act');
    // });

    toggles.addEventListener('click', (e) => {
      if (Nav.classList.contains('Act')) {
        unlock(Nav, { overflowType: 'clip' });
      } else {
        lock(Nav, { overflowType: 'clip' });
      }
      Nav.classList.toggle('Act');
      toggles.classList.toggle('Act');
    });

    const scroll = new SmoothScroll('a[href*="#"]', {
      speed: 500,
      header: '.p_headerWrap',
      topOnEmptyHash: true,
      speedAsDuration: true,
      // offset: 10,
      easing: 'easeInOutCubic',
      updateURL: false,
    });
  }
}
//
